/**
 * @module components/theme/Unauthorized/Unauthorized
 */

import { Unauthorized } from '@arpav/components/ArpavTheme';

export default Unauthorized;
